import SpinnerModal from "../../oversight-core/ui-elements/spinner/spinner";
import styles from "./chart-loading-overlay.module.scss";

interface IProps {
  show: boolean;
}

// Covers just its chart container (which must be position-relative) and keeps the spinner in view.
// The page-level SpinnerModal reserves 75vh, which put its spinner below the fold under a chart and
// left the chart looking blank while new data loaded.
const ChartLoadingOverlay = (props: IProps) => {
  if (!props.show) {
    return null;
  }

  return (
    <div className={styles.overlay} role="status" aria-label="Loading chart">
      <SpinnerModal show withOverlay={false} size="md" />
    </div>
  );
};

export default ChartLoadingOverlay;
